import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useNuJobsStore from "../../../store/nujobs.store";
import { useLocation } from "react-router-dom";

import LandingHeader from "../../header";
import logo from "../../../assets/landingFeatures/explorer.png";
import workflow from "../../../assets/landingFeatures/workflow.jpg";
import { Radio, Divider, Form, Input, message, Button, TimePicker, DatePicker,Card,Select } from "antd";
import {
  CodeOutlined,
  ApiOutlined,
  SettingOutlined,
  BookOutlined,
  BankOutlined,
  BuildOutlined,
  ExperimentOutlined,
  ShoppingCartOutlined,
  MenuOutlined,
  CloseOutlined
} from "@ant-design/icons";

import "./jobListingPage.scss";
import JobListingsSearch from "../jobListingSearch";
import FooterNuJobs from "../../footerNuJobs";
import JobListingWhoIsHiringNow from "../jobListingWhoIsHiringNow";
import JobListingEvents from "../jobListingEvents";
import JobListingsPageHeader from "../jobListingPageHeader";

export default function JobListingsPage() {
const { Meta } = Card;
const navigate = useNavigate();

  // Scrolls to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const encodeJson = (values) => {
    let encodedJsonValues = {};
    encodedJsonValues.keywords = values.keywords;
    encodedJsonValues.city = values.location;
    encodedJsonValues.category = []
    encodedJsonValues.category[0] = values.category;
    encodedJsonValues.timestamp = 0;
    encodedJsonValues.postingdate = "All";
    encodedJsonValues.pagenum = 1;
    encodedJsonValues.maxPerPage = 10;

    //from values
    encodedJsonValues.minexp = values.minexp;
    encodedJsonValues.maxexp = values.maxexp || null;
    encodedJsonValues.minctc = null;
    encodedJsonValues.maxctc = null;
    encodedJsonValues.noticeperiod = [];
    encodedJsonValues.postingdate = [];
    encodedJsonValues.workmode = null;
    encodedJsonValues.diversity = values.diversity || null;
    encodedJsonValues.role = [];
    encodedJsonValues.roletype = values.roletype || null;
    encodedJsonValues.companytype = null;
    encodedJsonValues.jobfor = null;
    return encodedJsonValues;
  };

  const { getOSAllJds, currentSearch } = useNuJobsStore();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const onCarouselCardClick = (item) => {
    const encodedJsonValues = encodeJson({ category: item.value });

    getOSAllJds(encodedJsonValues, handleResults);
  };

  const setAllLevelJobs = (type) => {
    let encodedJsonValues = {};

    switch (type) {
      case "exp":
        encodedJsonValues = encodeJson({ minexp: 4, maxexp: 20 });

        break;
      case "fresher":
        encodedJsonValues = encodeJson({ minexp: 0, maxexp: 1 });
        break;
      case "diversity":
        encodedJsonValues = encodeJson({ diversity: "Yes" });
        break;
      case "leadership":
        encodedJsonValues = encodeJson({
          roletype: ["Lead", "Director", "Manager", "VP"],
        });

        break;
      default:
        break;
    }
    getOSAllJds(encodedJsonValues, handleResults);
  };

  const handleSignin = () => {
    navigate("/nujobsotpprocess", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });
  };


  const handlePostJobs = () => {
    navigate("/otpprocess/nujobs", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });    
  };

  const jobCategories = [
    {
      title: "AI/ML Jobs",
      desc: "Explore Now",
      value: "aiml",
      icon: <ExperimentOutlined style={{ fontSize: 28, color: "#2476b5" }} />,
    },
    {
      title: "Software and Tech Jobs",
      desc: "Explore Now",
      value: "it",
      icon: <CodeOutlined style={{ fontSize: 28, color: "#2476b5" }} />,
    },
    {
      title: "VLSI Jobs",
      desc: "Explore Now",
      value: "vlsi",
      icon: <ApiOutlined style={{ fontSize: 28, color: "#2476b5" }} />,
    },
    {
      title: "Embedded Jobs",
      desc: "Explore Now",
      value: "embedded",
      icon: <SettingOutlined style={{ fontSize: 28, color: "#2476b5" }} />,
    },
    {
      title: "Automotive Jobs",
      desc: "Explore Now",
      value: "automotive",
      icon: <BuildOutlined style={{ fontSize: 28, color: "#2476b5" }} />,
    },
    {
      title: "BFSI Jobs",
      desc: "Explore Now",
      value: "BFSI",
      icon: <BankOutlined style={{ fontSize: 28, color: "#2476b5" }} />,
    },
    {
      title: "Industrial Jobs",
      desc: "Explore Now",
      value: "industrial",
      icon: <ShoppingCartOutlined style={{ fontSize: 28, color: "#2476b5" }} />,
    },
    {
      title: "Teaching Jobs",
      desc: "Explore Now",
      value: "teaching",
      icon: <BookOutlined style={{ fontSize: 28, color: "#2476b5" }} />,
    },
    {
      title: "Mechanical Jobs",
      desc: "Explore Now",
      value: "mechanical",
      icon: <BookOutlined style={{ fontSize: 28, color: "#2476b5" }} />,
    },
  ];

  useEffect(() => {
  }, []);

  const [noJobsFoundString, setNoJobsFoundString] = useState("");
  const handleResults = (num) =>{
    if(num >0){
       navigate('/jobListingSearchResultsPage')
       setNoJobsFoundString("")
    }else{
      setNoJobsFoundString("No Jobs Found")
    }
  }

  return (
    <div className="jobListingpage-wrapper">

       <JobListingsPageHeader/>
       
       <div className="jobListingpage-title">
         <JobListingsSearch resultHandler ={handleResults} loggedIn = {false}/>
        <div className="jobListing-puncLineSmall jobNotFound">
            {noJobsFoundString}
         </div>         
         <div className="jobListing-puncLineSmall">
            One Platform. Multiple Employers · Direct & Partner Hiring · Hiring Events · Free for Candidates
         </div>

       <div className="jobListing-feature-heading">
            Explore Jobs by <span className="text-blue">Domain</span>           
      </div>       
        <div className="feature-carousil-wrapper">
          <div className="job-domain-grid">
            {jobCategories.map((item, index) => (
              <div key={index} className="job-domain-item">
                <Card
                  hoverable
                  bordered
                  onClick={() => onCarouselCardClick(item)}
                >
                  <div className="job-domain-icon">
                    {item.icon}
                  </div>

                  <Meta
                    title={item.title}
                    description={item.desc}
                  />
                </Card>
              </div>
            ))}
          </div>
        </div>      
        <div className="jobListing-feature-heading">
            <span className="text-blue">Who's Hiring Now</span> on NuJobs
        </div>
        <JobListingWhoIsHiringNow />
        <div className="jobListing-feature-heading">
            Upcoming <span className="text-blue">Hiring Events</span>
        </div>        
        <JobListingEvents/>
        <div className="jobListing-feature-heading">
            Jobs For <span className="text-blue">All Levels</span> 
        </div>
        <div className="jobListing-level-card-wrapper">
          <div className="jobListing-level-card">
            <Card
              title="Experienced"
              bordered={false}
              extra={<a href="#">60 Jobs</a>}
              onClick={() => setAllLevelJobs("exp")}
            >
              Jobs for experienced professionals
            </Card>
          </div>
          <div className="jobListing-level-card">
            <Card
              title="Freshers"
              bordered={false}
              extra={<a href="#">40 Jobs</a>}
              onClick={() => setAllLevelJobs("fresher")}
            >
              Jobs for college graduates with up to 1 year of experience
            </Card>
          </div>
          <div className="jobListing-level-card">
            <Card
              title="Diversity Jobs"
              bordered={false}
              extra={<a href="#"> 300 Jobs</a>}
              onClick={() => setAllLevelJobs("diversity")}
            >
              Professional opportunities for women.
            </Card>
          </div>
          <div className="jobListing-level-card">
            <Card
              title="Leadership Roles"
              bordered={false}
              extra={<a href="#"> 60 Jobs</a>}
              onClick={() => setAllLevelJobs("leadership")}
            >
              Executive,Management level Openings
            </Card>
          </div>
        </div>
                                                         
       </div>

       <div className="landing-footer">
          <FooterNuJobs/>
       </div>         
    </div>
  );
}
